// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum KafkaDltTopic {
  Eshop = "ESHOP",
  EshopPayment = "ESHOP_PAYMENT",
  Kiosk = "KIOSK",
}
export default KafkaDltTopic;
